import { ActionType } from "../types";
import Modal from "react-bootstrap/esm/Modal";
import { Registry } from "./ComponentRegistry";

export const ActionsDialog = ({ show, onSelect, onHideModal }: {
    show: boolean,
    onSelect: (type: ActionType) => void,
    onHideModal: () => void,
}) => {
    const actions = Registry.actions;

    const handleOnSelect = (type: ActionType) => {
        onSelect(type);
        onHideModal();
    }

    return (
        <div>
            <Modal show={show} onHide={onHideModal} dialogClassName="min-w-75">
                <Modal.Header closeButton>
                    <Modal.Title>Action Types</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-wrap justify-content-start">
                        {actions.map(action => (<ActionTypeButton
                            key={action.type}
                            type={action.type}
                            onSelect={handleOnSelect} />
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

const ActionTypeButton = ({ type, onSelect }: {
    type: ActionType,
    onSelect: (type: ActionType) => void
}) => {
    return <div className="w-xl-25 py-1 px-2" >
        <button
            type="button"
            title={type}
            onClick={() => onSelect(type)}
            className="btn btn-outline btn-outline-primary w-100">
            <div className="d-flex align-items-center text-truncate">
                <i className="las la-object-group text-gray-700 fs-1"></i>
                <div className='fw-semibold text-start text-gray-700 flex-fill fs-7'>
                    {type}
                </div>
            </div>
        </button>
    </div>
}